// /ricerca: the new search (F07) for a caller with `features.search_v2` in
// /me, the page of today («In sviluppo») for everyone else, and again the
// page of today when the api answers 404 while the page is open (the switch
// turned off: the search asks /me again, SearchPage gives the page back).
import { PanelStatus } from "../components/PanelStatus";
import { hasSearchV2 } from "../features/auth/adapt";
import { useMe } from "../features/auth/api";
import { SearchPage } from "../features/search/SearchPage";
import { RicercaPage } from "./InDevelopmentPages";

export const CHECKING_SEARCH = "Caricamento della ricerca…";

export function SearchRoute() {
  const me = useMe();
  // in dev mode the app does not wait for /me (App.tsx): neither page until it has answered; a status row, as
  // App's own while the session is checked
  if (me.isPending) return <PanelStatus indent={false}>{CHECKING_SEARCH}</PanelStatus>;
  if (!hasSearchV2(me.data)) return <RicercaPage />;
  return <SearchPage off={<RicercaPage />} />;
}
